import Select, { Props as SelectProps, StylesConfig } from "react-select";
import { Box, BoxProps } from "@mui/material";
import { SInputProps } from "components/parts";
import { useRecoilValue } from "recoil";
import { focusState } from "states";
import { STheme } from "components/styles";

/**
 * セレクトボックス
 */

/**
 * プロパティ
 */
export type SSelectProps = Partial<SelectProps> &
  Pick<
    SInputProps,
    "focusId" | "label" | "index" | "formRef" | "disabled" | "required"
  > &
  Pick<BoxProps, "gridColumn" | "gridRow"> &
  Partial<{ error: boolean }>;

/**
 * セレクトボックス
 *
 * @param props
 * @returns JSX.Element
 */
export const SSelect = ({
  focusId,
  index,
  formRef,
  gridColumn,
  gridRow,
  error,
  ...props
}: SSelectProps): JSX.Element => {
  // フォーカス設定
  const { focusRef, move } = useRecoilValue(focusState(focusId ?? ""));

  if (error) {
    styles = {
      ...styles,
      container: (base) => ({ ...base, borderColor: STheme.selects.required }),
    };
  }

  return (
    <Box gridColumn={gridColumn} gridRow={gridRow}>
      <Select
        {...props}
        ref={(element) => {
          formRef(element);
          focusRef(index, element);
        }}
        onKeyDown={(event) => {
          if (event.key === "Enter") event.stopPropagation();
          props.onKeyDown?.call(this, event);
          move(index, event);
        }}
        tabIndex={index ?? -1}
        placeholder={null}
        backspaceRemovesValue
        closeMenuOnSelect
        styles={styles}
      />
    </Box>
  );
};

let styles: StylesConfig = {
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  control: (base) => ({
    ...base,
    fontSize: "0.8rem",
    borderRadius: "0px",
    height: "24px",
    minHeight: "24px",
  }),
  clearIndicator: (base) => ({
    ...base,
    margin: "0px",
    padding: "2px",
    paddingTop: "5px",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    margin: "0px",
    padding: "2px",
    paddingTop: "5px",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: "20px",
    minHeight: "20px",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    width: "0px",
    height: "0px",
    minHeight: "0px",
    margin: "0px",
  }),
  valueContainer: (base) => ({
    ...base,
    height: "20px",
    minHeight: "20px",
    padding: "0px",
  }),
  singleValue: (base) => ({
    ...base,
    margin: "0px",
    paddingLeft: "4px",
    paddingTop: "0px",
    paddingBottom: "0px",
  }),
  input: (base) => ({
    ...base,
    margin: "0px",
    paddingLeft: "4px",
    paddingTop: "0px",
    paddingBottom: "0px",
  }),
};
